<template>
	<div>
		<div class="wd-m-t-20 wd-m-b-20 tabdetail">
			<el-tabs type="border-card">
				<el-tab-pane label="收藏商品">
					<el-row class="wd-theme-back wd-h-40 wd-lh-40 wd-theme-333">
						<el-col :span="15" class="wd-text-center">商品</el-col>
						<el-col :span="3" class="wd-text-center">单价</el-col>
						<el-col :span="3" class="wd-text-center">库存</el-col>
						<el-col :span="3" class="wd-text-center">操作</el-col>
					</el-row>
					<el-row class="wd-theme-333 wd-border-bottom wd-flex wd-p-10" v-for="(item, index) in wddatalist" :key="index">
						<el-col :span="15">
							<div  class="wd-flex wd-row-left wd-cursor" @click="gotogoodsdetail(item.goodsid, item.goodsname)" >
								<div class="img wd-row-noshrink"><el-image :src="$wdpicurl(item.pic1)" class="img"></el-image></div>
								<div class="wd-row-grow wd-m-l-10 wd-text-left">{{ item.goodsname }}</div>
							</div>
						</el-col>
						<el-col :span="3" class="wd-text-center">¥{{ item.retailprice|amountFormatter }}</el-col>
						<el-col :span="3" class="wd-text-center"><el-tag type="success">库存充足</el-tag></el-col>
						<el-col :span="3" class="wd-text-center"><el-button type="warning" size="mini" @click="historydel(index)">删除</el-button></el-col>
					</el-row>
					<div class="wd-fr">
						<el-pagination
							:total="cnt"
							:background="true"
							layout="prev, pager, next"
							@size-change="pagesizechange"
							@current-change="currentchange"
							@prev-click="prevclick"
							@next-click="nextclick"
						></el-pagination>
					</div>
				</el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Historylist',
	data() {
		return {
			wddatalist: [],
			cnt: -1,
			page: 0
		};
	},
	methods: {
		pagesizechange(e) {
			this.page=e-1;
			this.loaddata();
		},
		currentchange(e) {
			this.page=e-1;
			this.loaddata();
		},
		prevclick(e) {
			this.page=e-1;
			this.loaddata();
		},
		nextclick(e) {
			this.page=e-1;
			this.loaddata();
		},
		historydel(index) {
			var goodsid = this.wddatalist[index].goodsid;
			this.$wd_request('memfavopt', { goodsid: goodsid }).then(() => {
				this.$wd_toast('删除成功');
				this.wddatalist.splice(index, 1);
			});
		},
		loaddata() {
			if (this.cnt == -1) {
				this.page = 1;
			} else {
				if (this.page * this.$wd_limit >= this.cnt) {
					return;
				} else this.page++;
			}
			this.$wd_request('memfav', { cnt: this.cnt, page: this.page,limit:this.$wd_limit },true,".memdetail").then(data => {
				if (this.cnt == -1) {
					this.wddatalist = data.value;
					this.cnt=data.cnt;
				} else {
					this.wddatalist = data.value;
					// this.wddatalist = this.wddatalist.concat(data.value);
				}
			});
		},
		gotogoodsdetail(goodsid, goodsname) {
			this.$router.push({
				name: 'Goodsinfo',
				query: {
					goodsid: goodsid,
					goodsname: goodsname
				}
			});
		}
	},
	activated() {
		this.loaddata();
	},
	created() {
		this.loaddata();
	}
};
</script>

<style lang="scss" scoped>
.img {
	width: 50px;
	height: 50px;
}
</style>
